import { Globe2 } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { useLanguage } from "@/i18n";

export default function International() {
    const { t } = useLanguage();

    return (
        <section id="esperienza-int" data-testid="international-section" className="relative scroll-mt-20">
            <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
                <SectionHeading
                    chapter={t.international.chapter}
                    eyebrow={t.international.eyebrow}
                    title={t.international.title}
                    testid="international-heading"
                />

                <Reveal delay={0.1}>
                    <p
                        data-testid="international-statement"
                        className="max-w-3xl text-base leading-relaxed text-slate-300 sm:text-lg"
                    >
                        {t.international.statement}
                    </p>
                </Reveal>

                <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
                    {t.international.countries.map((c, i) => (
                        <Reveal key={c.code} delay={i * 0.06} className="h-full">
                            <div
                                data-testid={`country-card-${c.code.toLowerCase()}`}
                                className="group h-full border border-navy-600 bg-navy-950 p-6 transition-colors hover:border-sky-400"
                            >
                                <div className="flex items-start justify-between">
                                    <span className="font-mono text-4xl font-bold text-[#C9D8EC] transition-colors group-hover:text-sky-400">
                                        {c.code}
                                    </span>
                                    <Globe2 className="h-5 w-5 text-sky-400" />
                                </div>
                                <p className="mt-6 font-display text-lg font-semibold text-slate-50">{c.name}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
